module.exports = __webpack_public_path__ + "static/media/Hakamo-o_gaussian2.30f9cb94.png";